import React, { useState, useEffect } from 'react';
import Hero from './components/Hero';
import SearchSection from './components/SearchSection';
// import FeaturedYachts from './components/FeaturedYachts';
// import Destinations from './components/Destinations';
// import WhyChooseUs from './components/WhyChooseUs';
// import Testimonials from './components/Testimonials';
import Footer from './components/Footer';
// import ThemeToggle from './components/ThemeToggle';
import './App.css';

function App() {
  const [searchParams, setSearchParams] = useState({
    destination: '',
    guests: '',
    date: '',
    yachtType: ''
  });

  const [theme, setTheme] = useState('dark');

  // Load theme from localStorage on component mount
  useEffect(() => {
    const savedTheme = localStorage.getItem('theme') || 'dark';
    setTheme(savedTheme);
    document.documentElement.setAttribute('data-theme', savedTheme);
  }, []);

  // Update theme and save to localStorage
  const toggleTheme = () => {
    const newTheme = theme === 'light' ? 'dark' : 'light';
    setTheme(newTheme);
    localStorage.setItem('theme', newTheme);
    document.documentElement.setAttribute('data-theme', newTheme);
  };

  const handleSearch = (params) => {
    setSearchParams(params);
    // Here you would typically handle the search logic
    console.log('Search params:', params);
  };

  return (
    <div className="App">
      {/* <ThemeToggle theme={theme} toggleTheme={toggleTheme} /> */}
      {/* <Header /> */}
      <Hero />
      <SearchSection onSearch={handleSearch} />
      {/* <FeaturedYachts />
      <Destinations />
      <WhyChooseUs />
      <Testimonials /> */}
      <Footer /> 
    </div>
  );
}

export default App; 